import React, { useEffect, useState } from 'react';
import Main from '../../landing/Main';
import { useLocation } from 'react-router-dom';
import NewContent from '../Content/NewContent';
import NewNavbar from '../NavBar/NewNavBar';
import { Helmet } from 'react-helmet';

export default function NewHomePage(props) {
  var time = null;
  const [isSet, SetIsSet] = React.useState(false)
  const urlval = useLocation();

  useEffect(() => {
    if (!time) {
      props?.timer2();
      time = true;
    }
    return () => props?.timer2(urlval);
  }, [props.timer2])

  return (
    <div className={`container-fluid p-0 m-0 ${props.pathname} inter`}>
      <Helmet>
        <title>{`${props?.pathname?.partner_name} | Calque`}</title>
        <meta name="description" content={`${props?.pathname?.partner_name} now offers innovative Buy-Before-You-Sell solutions powered by Calque, a fintech company that provides a binding backup contract-known as a Guaranteed Backup Agreement (GBA)-on a borrower’s home.`} />
        <meta name="keywords" content="trade in mortgage, trade-in mortgage, trade in loan, trade up mortgage, slide loan, slide mortgage, glide loan, trade my home, home swap, mortgage swap, swamp my home, home trade, buy before you sell, buy-first solution, buy-first, Calque, house swap" />
        <meta property="og:title" content={`${props?.pathname?.partner_name} | Calque`} />
        <meta property="og:description" content={`${props?.pathname?.partner_name} now offers innovative Buy-Before-You-Sell solutions powered by Calque, a fintech company that provides a binding backup contract-known as a Guaranteed Backup Agreement (GBA)-on a borrower’s home.`}/>
        <meta property="og:url" content={`https://bbys.calqueinc.com/${props?.pathname?.url_path}`} />
        <link rel="canonical" href={`https://bbys.calqueinc.com/${props?.pathname?.url_path}`} />
      </Helmet>
      {
        props.pathname.partner_id ?
          <>
            <NewNavbar {...props} partner={props.pathname} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} calendlyUrl={props.calendlyUrl} addressGlobal={props.addressGlobal} />
            <NewContent {...props} SetIsSet={SetIsSet} isSet={isSet} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} calendlyUrl={props.calendlyUrl} addressGlobal={props.addressGlobal} partner={props.partner} pathname={props.pathname} GAtimer={props.GAtimer} GAtimerFinish={props.GAtimerFinish} partnerContactRole={props.partnerContactRole} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>
          </>
          :
          <>
            <Main {...props} setEfficientDefault={props.setEfficientDefault} efficientDefault={props.efficientDefault} handleEfficientDefault={props.handleEfficientDefault} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} calendlyUrl={props.calendlyUrl} addressGlobal={props.addressGlobal} partner={props.partner} GAtimer={props.GAtimer} GAtimerFinish={props.GAtimerFinish} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>
          </>
      }
    </div>
  )
}